import { render } from "./TranquilCore.vue?vue&type=template&id=258acdcf"
import script from "./TranquilCore.vue?vue&type=script&lang=js"
export * from "./TranquilCore.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__